export const getReviews = async (productName) => {
    const response = await fetch(`/api/getReviews?productName=${productName}`, { method: "GET" });
    return (await response.json());
};
